<template>
	<div class="cco-cartLineItem" :class="['cco-cartLineItem--' + version]">
		<a :href="lineItem.url">
			<img
				class="cco-cartLineItem__image"
				:src="lineItem.image.url"
				:alt="lineItem.image.title"
			/>
		</a>
		<div class="cco-cartLineItem__details" v-if="!lineItem.isSubscription">
			<div class="top">
				<div class="info">
					<div class="info__title-container">
						<p class="info__brand">{{ lineItem.brand }}</p>
						<p class="info__title">{{ lineItem.title }}</p>
					</div>
					<p class="info__secondary" v-if="lineItem.secondary">
						{{ translations[lineItem.secondary] ?? lineItem.secondary }}
					</p>
					<p v-if="version == 'full'" class="info__price">
						{{ lineItem.qty }}x {{ lineItem.unit.saleAsCurrency }}
					</p>
					<span v-if="version == 'full'" class="info__favorite">
						<Favorite :id="lineItem.productId" :version="'inline'"></Favorite>
					</span>
				</div>
				<div class="o-labels o-labels__label o-labels--sale" v-if="isCampaign">
					<span>{{ translations["Gift"] }}</span>
				</div>
			</div>
			<div class="pricing">
				<PriceObject :price="lineItem.total" />
				<Spinner
					version="cart"
					:qty="parseInt(lineItem.qty)"
					:lineItem="lineItem"
					v-if="hasSpinner"
				>
				</Spinner>
				<p v-else>{{ lineItem.qty }} {{ translations["Pcs"] }}</p>
			</div>
		</div>
		<div
			v-else
			class="cco-cartLineItem__details cco-cartLineItem__details--subscription"
		>
			<div class="info">
				<p class="info__title">{{ lineItem.title }}</p>
				<Spinner
					v-if="showSpinner"
					version="cart"
					:qty="parseInt(lineItem.qty)"
					:lineItem="lineItem"
					:isSingle="lineItem.isSubscription"
				>
				</Spinner>
			</div>
			<div class="pricing">
				<PriceObject :price="lineItem.total" />
			</div>
		</div>
	</div>
</template>

<script>
import PriceObject from "@/vue/components/objects/PriceObject.vue";
import Spinner from "@/vue/components/commerce/objects/Spinner.vue";
import Favorite from "@/vue/components/commerce/Favorite.vue";

export default {
	name: "CartLineItem",
	components: { PriceObject, Spinner, Favorite },
	props: {
		lineItem: {
			type: [Object, Boolean],
			default: false,
		},
		version: {
			type: String,
			default: "cart",
		},
		showSpinner: {
			type: Boolean,
			default: true,
		},
	},
	data: () => {
		return {};
	},
	methods: {},
	created() {},
	computed: {
		infoTitle() {
			return `${this.lineItem.brand + ";"} ${this.lineItem.title}`;
		},

		hasSpinner() {
			if (!this.showSpinner) {
				return false;
			}

			if (!this.lineItem) {
				return true;
			}

			if (this.isCampaign) {
				return false;
			}

			return this.showSpinner;
		},

		isCampaign() {
			if (this.lineItem.status == "campaign") {
				return true;
			}

			return false;
		},
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-cartLineItem {
	border-bottom: $e-border;
	padding-top: 16px;
	padding-bottom: 16px;
	display: flex;
	gap: 8px;

	&__image {
		@include size-fix(80px, 80px);
	}
	&__details {
		width: 100%;
		display: flex;
		justify-content: space-between;

		.top {
			display: flex;
			justify-content: space-between;
		}

		.info {
			display: flex;
			flex-direction: column;
			flex: 1;

			.title,
			.secondary,
			.price__unit,
			.ccf-price {
				height: 20px;
				line-height: 20px;
			}

			&__title-container {
				line-height: 21px;
			}

			&__title {
				@include text-overflow();
				font-weight: $f-semibold;
			}

			&__price {
				display: flex;
				.ccf-price {
					display: flex;
					gap: 8px;
					margin-bottom: 12px;
				}
			}
			&__favorite {
				@include hover-underline($reverse: true);
				font-weight: $f-medium;
				line-height: 18px;
				font-size: 14px;
			}
		}
		.pricing {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			.ccf-price {
				margin-bottom: 6px;
			}
		}

		&--subscription {
			flex-direction: row !important;
			.pricing {
				margin-top: 0 !important;
				align-items: flex-start !important;
			}
			.info {
				.cco-spinner {
					&__actions {
						justify-content: center;
						.decrease {
							padding: 0 18px;
						}
					}
					&--cart {
						min-width: 60px !important;
						max-width: 60px !important;
					}
				}
				justify-content: space-between;
			}
		}
	}

	&--cart {
		.cco-cartLineItem {
			&__details {
				flex-direction: column;

				.pricing {
					margin-top: 8px;
					justify-content: space-between;
					align-items: flex-end;
					flex-direction: row-reverse;

					.ccf-price {
						margin-bottom: 0;
					}
				}
			}
		}
	}
}

@media all and (max-width: 445px) {
	.cco-cartLineItem {
		&--cart {
			.cco-cartLineItem__details {
				.pricing {
					flex-direction: column;
					align-items: flex-start;
					.cco-spinner {
						margin-top: 12px;
					}
				}
			}
		}
	}
}

@media all and (max-width: 435px) {
	.cco-cartLineItem {
		&--full {
			.cco-cartLineItem {
				&__details {
					flex-direction: column;
					align-items: flex-start;
					.pricing {
						margin-top: 18px;
						align-items: flex-start;
						.ccf-price {
							margin-bottom: 6px;
						}
					}
				}
			}
		}
	}
}

@media all and (max-width: 375px) {
	.cco-cartLineItem {
		&__image {
			@include size-fix(60px, 60px);
		}

		&__info {
			gap: 0px;
		}
	}
}

@media all and (max-width: 340px) {
	.cco-cartLineItem {
		&__image {
			@include size-fix(60px, 60px);
		}

		&__info {
			gap: 0px;

			.price {
				flex-direction: column;
			}
		}
	}
}
</style>
